import BaseList from 'records/BaseList';
import { List } from 'immutable';
import { AssetTransfers } from 'records/AssetTransfer';
import AssetTransferBase from 'records/AssetTransferBase';

import {
  ASSET_TRANSFER_ASYNC_ACTION_START,
  ASSET_TRANSFER_ASYNC_ACTION_ERROR,
  ASSET_TRANSFER_ASYNC_UPDATE_SUCCESS,
  ASSET_TRANSFER_UPDATE_SUCCESS,
  ASSET_TRANSFER_RESET_STATE,
  ASSET_TRANSFER_SUCCESS_ALERT,
  ASSET_TRANSFER_FAILURE_ALERT
} from 'actions/assetTransfer';


const initialState = new AssetTransferBase({
  loading: false,
  errorMessage: null,
  data: new List(),
  successAlert: false,
  failureAlert: false
});

const actionsMap = {
  [ASSET_TRANSFER_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [ASSET_TRANSFER_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [ASSET_TRANSFER_ASYNC_UPDATE_SUCCESS]: (state, action) => {
    const assetTransfers = AssetTransfers(action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: assetTransfers,
    });
  },
  [ASSET_TRANSFER_UPDATE_SUCCESS]: (state, action) => {
    return state.mergeDeep({
      data: action.data,
    });
  },
  [ASSET_TRANSFER_RESET_STATE]: () => {
    return initialState;
  },
  [ASSET_TRANSFER_SUCCESS_ALERT]: (state, action) => state.merge({
    loading: false,
    successAlert: action.payload,
  }),
  [ASSET_TRANSFER_FAILURE_ALERT]: (state, action) => state.merge({
    loading: false,
    failureAlert: action.payload,
  }),
};

export default function assetTransfer(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
